import { AuthSettings } from '@core/models/tfa.model';

export interface AuthStateModel {
	token: string;
	isAdmin: boolean;
	tfa: AuthSettings;
	recoveryCodes?: string[];
	loginCredentials?: {
		username: string;
		password: string;
	};
}

export const initialState: AuthStateModel = {
	token: null,
	isAdmin: null,
	tfa: null,
};
